export const createCompatibilityContext = () => {
  const checkedRevisions = new Map();
  const remember = (response) => {
    const items = response.data?.data ?? response.data;
    if (!Array.isArray(items)) return;
    items.forEach((item) => {
      const checks = Array.isArray(item.compatibility) ? item.compatibility : [item.compatibility];
      checks.filter(Boolean).forEach((check) => {
        const key = check.crm_plan_id ?? response.config?.params?.plan_id;
        if (key) checkedRevisions.set(String(key), check.revision_id ?? null);
      });
    });
  };
  const apply = (request) => {
    const match = request.url?.match(/(?:crm\/plans|plans)\/([^/]+)\//);
    if (request.method !== 'post' || !match || !checkedRevisions.has(match[1])) return request;
    const revision = checkedRevisions.get(match[1]);
    if (request.data instanceof FormData) request.data.set('checked_revision_id', revision ?? '');
    else request.data = { ...request.data, checked_revision_id: revision };
    return request;
  };
  return { remember, apply };
};
